import { get, isNull } from "lodash";

/**
 * Iterate over story cards and return once description is truthy
 *
 * @param object story
 * @return string description
 */

export const getDescription = story => {
  let description = "";
  const regex = /(<([^>]+)>)/gi; // Regex to escape html characters
  const storyObj = Object.assign({}, story);
  const cards = storyObj && storyObj.cards;

  cards &&
    cards.every(card => {
      const element = card["story-elements"].find(o => o.type === "text");
      if (element && element.text) {
        description = element.text.replace(regex, "");
        return false;
      }
    });

  return description;
};

/**
 * Returns slug conditionally based on section or collection
 *
 * @param object collection
 * @param array sections
 * @return string slug
 */

export const getSlug = (collection, sections = []) => {
  let slug = "#";

  if (collection && collection.slug) {
    const metadata = Object.keys(get(collection, ["metadata"], {}));
    const isSection = metadata.indexOf("section") !== -1;
    if (isSection) {
      const sectionId = collection.metadata.section[0].id;
      const section = sections.find(o => o.id === sectionId);

      if (section && !isNull(section["parent-id"])) {
        const parentSection = sections.find(o => o.id === section["parent-id"]);

        if (parentSection) {
          slug = `/${parentSection.slug}/${section.slug}`;
        }
      } else if (section && isNull(section["parent-id"])) {
        slug = `/${section.slug}`;
      }
    } else {
      slug = `/collection/${collection.slug}`;
    }
  }

  return slug;
};

export const getSectionSlug = (section, sections) => {
  let slug = "#";
  if (section && !isNull(section["parent-id"])) {
    const parentSection = sections.find(o => o.id === section["parent-id"]);

    if (parentSection) {
      slug = `/${parentSection.slug}/${section.slug}`;
    }
  } else if (section && isNull(section["parent-id"])) {
    slug = `/${section.slug}`;
  }
  return slug;
};
/**
 * Instantiates an image element for Lightbox
 *
 * @param object story
 * @returns object
 */
export const createImageElement = story => {
  return Object.assign(
    {},
    {
      id: story.id,
      "image-metadata": story["hero-image-metadata"],
      "image-s3-key": story["hero-image-s3-key"],
      type: "image"
    }
  );
};

export const storyShareClickHandler = (storyContentId, storyUrl) => event => {
  return (
    global.app &&
    global.app.registerStoryShare &&
    global.app.registerStoryShare(storyContentId, event.currentTarget.getAttribute("data-social-media-type"), storyUrl)
  );
};
